import React from 'react';
import PropTypes from 'prop-types';
import TextInputBase from './TextInputBase';

class TextInput extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override TextInputBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <TextField> */
    className: PropTypes.string,
    /** If `true`, the input will not have an underline. */
    disableUnderline: PropTypes.bool,
    /** If `true`, textfield will be in error state */
    hasError: PropTypes.bool,
    /** If `true`, password will be visible */
    showPassword: PropTypes.bool,
    /** Override or extend default styles */
    styles: PropTypes.object,
    /** Name attribute of the `input` element. */
    name: PropTypes.string,
    /** Value of `input` element */
    value: PropTypes.string,
    /** Type of the input element. It should be a valid HTML5 input type. */
    type: PropTypes.string,
    /** Text used for input label */
    label: PropTypes.string,
    /** If `true`, the label is displayed as required. */
    required: PropTypes.any,
    /** Callback fired when value is changed */
    onChange: PropTypes.func,
  };

  static defaultProps = {
    styleType: 'default',
    hasError: false,
    disableUnderline: true,
    showPassword: false,
  };

  getStyles = type => {
    switch (type) {
      case 'search':
        return {
          textField: {
            maxWidth: '100%',
            backgroundColor: '#FFF',
            border: '1px solid #C4C4CE',
          },
          formLabel: {
            color: '#747480',
            fontSize: '0.9rem',
          },
        };
      case 'chat':
        return {
          textField: {
            maxWidth: '100%',
          },
          formLabel: {
            fontSize: '12px',
            paddingLeft: '18px',
          },
          formControl: {
            transform: 'translate(0, 18px) scale(1)',
          },
        };
      case 'documentLandingSearch':
        return {
          root: {
            border: '0.5px solid #EAEAF2',
            backgroundColor: '#F6F6FA',
          },
          inputRoot: {
            marginTop: '16px !important',
          },
          textField: {
            height: '51px',
            maxWidth: '100%',
          },
          formLabel: {
            color: '#747480',
            fontSize: '0.9rem',
          },
          floatLabel: {
            margin: '0 0 0 0.5rem',
          },
          floatLabelShrink: {
            margin: '0.5rem 0 0 0.5rem',
            fontSize: '10px',
          },
        };
      case 'date':
        return {
          inputRoot: {
            height: '50px',
            top: '0px',
            left: '-4px',
            paddingLeft: '7px',
            position: 'relative',
            margin: '0px !important',
          },
          inputDom: {
            left: '4px',
            top: '9px',
            position: 'relative',
            height: '32px',
            '&::placeholder': {
              position: 'relative',
              top: '1px',
              left: '0px',
            },
          },
        };

      case 'login':
        return {
          textField: {
            backgroundColor: '#181820',
            maxWidth: '520px',
            height: '64px',
          },
          formControl: {
            transform: 'translate(0, 24px) scale(1)',
          },
          textFieldFocus: {
            border: 'solid 1px #181820',
          },
          inputRoot: {
            color: '#FFF',
            paddingLeft: '14px',
            fontFamily: 'arial, sans-serif !important',
          },
          formLabel: {
            paddingLeft: '16px',
            color: '#FFF',
          },
          formHelperText: {
            position: 'absolute',
            bottom: '-17px',
          },
          visibilityIcon: {
            top: 'auto',
          },
          visibilityIconRoot: {
            color: '#FFF',
          },
        };

      default:
        return {};
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <TextInputBase styles={styles} {...otherProps} />;
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/ui/library/TextInput/TextInput.js